import React from "react";
import QuantityButton from "../QuantityButton/QuantityButton";
import QuantityBoxLogic from "./QuantityBoxLogic";

import styles from "./quantity_box.module.css";

const commonStyle = {
  fontSize: '1.5rem',
  width: "50px",
  backgroundColor: "#4B5781",
  color: "#fff"
}

const QuantityBox = ({ id, date, limit }) => {
  const { quantity, increment, decrement } = QuantityBoxLogic(id, date, limit);

  return (
    <div className={styles.QuantityBox}>
      <QuantityButton
        content={'-'}
        {...commonStyle}
        borderBottomLeftRadius={"5px"}
        borderTopLeftRadius={"5px"}
        handleClick={decrement}
      />
      <QuantityButton
        content={quantity}
        width={"59px"}
        backgroundColor={"#fff"}
        color={"#6E6E6F"}
      />
      <QuantityButton
        content={'+'}
        {...commonStyle}
        borderBottomRightRadius={"5px"}
        borderTopRightRadius={"5px"}
        handleClick={increment}
      />
    </div>
  );
};


export default QuantityBox;
